/** Convert plain quotes to smart quotes */
export default function convertPlainQuotes(string: string) {
	// Initialize
	const matches = [/(^| )'/g, /(^| )"'/g, /(^| )'"/g, /(^| )"/g, /([^\d\s]['"]?)'/g, /([^\d\s]['"]?)"/g];
	const replacements = ['$1‘', '$1"‘', '$1‘"', '$1“', '$1’', '$1”'];
	
	
	// Perform regex replacements
	let replacedString = string;
	
	for (const [index, match] of matches.entries()) {
		replacedString = replacedString.replace(match, replacements[index]);
	}
	
	
	// Return
	return replacedString;
}
